<app-base-modal [title]="'user-profile.activeSessions.termination.confirmation' | translate">
  <p class="modal__description">
    {{ 'user-profile.activeSessions.termination.description' | translate }}
  </p>

  <app-modal-controls
    (onSecondaryAction)="close()"
    (onPrimaryAction)="terminate()"
    secondaryActionTextKey="user-profile.activeSessions.termination.cancel"
    primaryActionTextKey="user-profile.activeSessions.termination.terminate"
  />
</app-base-modal>
